import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls smoothly to the element matching location.hash whenever it changes.
 * If no hash, scrolls to top.
 */
export const useScrollToHash = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.slice(1);
            // Defer to allow content to mount
            setTimeout(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 80);
        } else {
            window.scrollTo({ top: 0 });
        }
    }, [location.pathname, location.hash]);
};
